/** Shown after a failed submit when `invalidNames` contains `fieldName`. */
export default function ModalFieldRequiredError({ invalidNames, fieldName }) {
  if (!invalidNames || !invalidNames.has(fieldName)) return null;
  return (
    <span className="fm-field-required-error" role="alert">
      This field is required
    </span>
  );
}
